const firebaseConfig = {
    apiKey: "AIzaSyBBCEu1SXragfOECRjDD0NpEjxU_32SgzY",
    authDomain: "travel-guru-app-firebase.firebaseapp.com",
    databaseURL: "https://travel-guru-app-firebase.firebaseio.com",
    projectId: "travel-guru-app-firebase",
    storageBucket: "travel-guru-app-firebase.appspot.com",
    messagingSenderId: "921456919680",
    appId: "1:921456919680:web:7e60927ad3e4d1ebdb9265"
  };

export default firebaseConfig;